/**
 * Build the tenant site origin for a given organization subdomain (marketing / apex host).
 */
export function tenantOriginForSubdomain(subdomain: string): string {
  const { protocol, hostname } = window.location;
  const baseHost =
    hostname.split('.').length === 3
      ? hostname.split('.').slice(1).join('.')
      : hostname;
  return `${protocol}//${subdomain}.${baseHost}`;
}

/** True when this document is not the top window (e.g. booking embed on a marketing site). */
export function isEmbeddedInIframe(): boolean {
  try {
    return Boolean(window.top && window.top !== window.self);
  } catch {
    // Access to window.top can throw if cross-origin.
    return true;
  }
}

/**
 * Assign location on the top window so we leave the marketing iframe
 * (iframe -> tenant hits CSP frame-ancestors).
 *
 * Do not use this after setting auth cookies in an iframe: the embed is
 * third-party, so those cookies are a different jar than first-party Trustvideo.
 */
export function assignLocationBreakingOutOfIframe(url: string): void {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.assign(url);
      return;
    }
  } catch {
    // Access to window.top can throw if cross-origin; fall through.
  }
  window.location.assign(url);
}
